/* globals $:false */

import { decodeAndUnescape, encodeEscapes, unQuote } from '../fields/recordm.fields.js';
import ClipboardM from "../model/recordm.model.clipboard";
import UriBuilder from "../helpers/module.uribuilder";
import utils from '@cob/ui-genesis/cob.utils.js';

// Component for making a field behave like a link field that uses the clipboard feature to create an instance of another def
// The syntax expected is:
// $create(def_id, target_Field_1 = local_field, target_Field_2 = 'literal value', etc.... )
//
// def: the def_id
// fields: an array of field names = field value expressions
// Supports the following escapes: \( \) \, \=
//
// args:
// * `The keyword description string "def_id, target_Field_1 = local_field, target_Field_2 = 'literal value'"
// Supports the following escapes anywhere in the args: \( \) \, \=
//
// confs:
// * `id`: the input attr id
// * `text`: the text of the link. Defaults to "Create".
// * `initialHref`: The initial href
//
// callbacks (passed in confs param)
// *getValueOf(fieldName) // callback for getting a local field value
const Create = function(core, def, fields, confs) {
    var
        _clipboardPairs,// an auxiliary array to hold json objects of each (field,value) pair
                        // and that will be used to build the clipboard obj
        _$link;

    var _confs = {
        id: core.locallyUniqueId(),
        text: "Create",
        initialHref: ""
    };

    if (confs) {
        utils.extend(_confs, confs, true);
    }

    var _onFieldChange = function(_evt, data) {
        //update clipboardPair (loop every pair since we may have the same localfield mapped to different target fields)
        _clipboardPairs.forEach(function(el) {
            if (el.localFieldName === data.name) {
                el.value = data.value;
            }
        });

        //rebuild url
        if(_$link) _$link.attr("href", _buildUrl());
    };


    //parses the fields array and builds the clipboardPairs helper obj
    var _init = function() {
        _clipboardPairs = fields.map(function(field) {
            var pair = unQuote(encodeEscapes(field)).split("=");
            var targetField = decodeAndUnescape(pair[0]).trim(),
                valOrLocalField = decodeAndUnescape(pair[1]).trim(),
                finalValue,
                isConstant = valOrLocalField.startsWith("'");

            if (isConstant) {
                finalValue = valOrLocalField.slice(1, -1);
            } else {
                finalValue = _confs.getValueOf(valOrLocalField);
                core.subscribe('field-value-change-byName-' + encodeURIComponent(valOrLocalField), _onFieldChange);
            }

            return {
                targetField: targetField,
                value: finalValue,
                localFieldName: isConstant ? undefined : valOrLocalField
            }
        });
    };

    var _render = function() {
        var $html = $([
            '<div class="inline">',
            '<a id="f' + _confs.id + '" class="link field-value cob-field-value create-link" target="' + (_confs.target ?? '_blank') + '">',
            _confs.text,
            '</a>',
            '</div>'
        ].join(''));

        _$link = $html.find("a");

        return $html;
    };

    const _buildUrl = function (){
        const newInstanceUrlData = new ClipboardM().buildClipboardObject(_clipboardPairs);
        return "#/"+UriBuilder.buildUriForCreateInstance(def, JSON.stringify(newInstanceUrlData));
    }

    var _onInstanceReady = function() {
        _init();
        _$link.attr("href", _buildUrl());
    };

    var _destroy = function() {
        _clipboardPairs
            .filter((cp) => cp.localFieldName)
            .forEach((cp) => core.unsubscribe('field-value-change-byName-' + encodeURIComponent(cp.localFieldName), _onFieldChange))
    }

    var _noop = function() {};

    return {
        render: _render,
        destroy: _destroy,

        clearError: _noop,
        showError: _noop,

        setValue: _noop,
        getValue: _noop,

        onInstanceReady: _onInstanceReady,
        onFieldChange: _onFieldChange,

        buildUrlFromSearchData:function(){
            _init();
            return _buildUrl();
        }
    }
};

export default Create;
